import { useCoreQuery } from "../../core/hooks/use-core-query.js";
import { useNotificationsQuery } from "../../core/hooks/use-notifications-query.js";
import { i18n } from "../../../utils/i18n.js";
import { Footer } from "../components/footer.js";
import { Header } from "../components/header.js";
import { Item } from "../components/item.js";
import "react";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { BadgeAnchor, Divider, Loading, Popover, Tooltip } from "@tecsinapse/cortex-react";
import { FiAlertCircle } from "react-icons/fi";
import { LuBell } from "react-icons/lu";
//#region src/modules/notifications/ui/list.tsx
var NotificationList = ({ showNotifications }) => {
	const { data: core } = useCoreQuery();
	const { data: notifications, error, isLoading, refetch } = useNotificationsQuery();
	const recentNotifications = (notifications ?? []).filter((notification) => notification.recente);
	const previousNotifications = (notifications ?? []).filter((notification) => !notification.recente);
	if (!showNotifications) return null;
	return /* @__PURE__ */ jsxs(Popover.Root, {
		trigger: "click",
		children: [/* @__PURE__ */ jsx(Popover.Trigger, { children: /* @__PURE__ */ jsx(Tooltip, {
			text: i18n._(
				/** i18n */
				{ id: "sZjLlB" }
			),
			children: /* @__PURE__ */ jsx(Popover.Trigger, { children: /* @__PURE__ */ jsx(Tooltip, {
				text: i18n._(
					/** i18n */
					{ id: "sZjLlB" }
				),
				children: /* @__PURE__ */ jsx("div", {
					onClick: async () => await refetch(),
					children: (core?.notificationCount ?? 0) > 0 ? /* @__PURE__ */ jsx(BadgeAnchor, {
						value: core?.notificationCount ?? 0,
						variants: {
							intent: "error",
							isAnchor: true,
							className: "text-[12px]"
						},
						children: /* @__PURE__ */ jsx(LuBell, {
							className: "text-secondary-medium hover:cursor-pointer",
							size: 24
						})
					}) : /* @__PURE__ */ jsx(LuBell, {
						className: "text-secondary-medium hover:cursor-pointer",
						size: 24
					})
				})
			}) })
		}) }), /* @__PURE__ */ jsxs(Popover.Content, {
			className: "bg-white",
			children: [
				/* @__PURE__ */ jsxs("div", {
					className: "flex bg-white flex-col w-[420px] h-[50vh]",
					children: [
						isLoading ? /* @__PURE__ */ jsx("div", {
							className: "flex justify-center items-center p-mili h-full",
							children: /* @__PURE__ */ jsx("p", {
								className: "font-bold text-primary-medium",
								children: /* @__PURE__ */ jsx(Loading, { className: "w-[2rem] h-[2rem]" })
							})
						}) : error ? /* @__PURE__ */ jsx("div", {
							className: "flex justify-center items-center p-mili h-full",
							children: /* @__PURE__ */ jsx("p", {
								className: "text-error-medium font-bold",
								children: i18n._(
									/** i18n */
									{ id: "s1Qipq" }
								)
							})
						}) : (notifications ?? []).length === 0 ? /* @__PURE__ */ jsxs("div", {
							className: "flex bg-white flex-col w-[420px]",
							children: [
								/* @__PURE__ */ jsx(Header, { title: i18n._(
									/** i18n */
									{ id: "sZjLlB" }
								) }),
								/* @__PURE__ */ jsx(Divider, {}),
								/* @__PURE__ */ jsxs("div", {
									className: "flex flex-col justify-center items-center p-mili",
									children: [
										/* @__PURE__ */ jsx(FiAlertCircle, {
											size: 24,
											className: "text-primary-medium"
										}),
										/* @__PURE__ */ jsx("p", {
											className: "font-bold text-h4 text-primary-medium",
											children: i18n._(
												/** i18n */
												{ id: "Gds-GM" }
											)
										}),
										/* @__PURE__ */ jsx("p", { children: i18n._(
											/** i18n */
											{ id: "TcARn6" }
										) })
									]
								})
							]
						}) : null,
						recentNotifications.length > 0 ? /* @__PURE__ */ jsxs(Fragment, { children: [
							/* @__PURE__ */ jsx(Header, { title: i18n._(
								/** i18n */
								{ id: "Gdt21R" }
							) }),
							/* @__PURE__ */ jsx(Divider, {}),
							/* @__PURE__ */ jsx("div", {
								className: "overflow-y-scroll",
								children: recentNotifications.map((notification) => /* @__PURE__ */ jsx(Item, { notification }, notification.id))
							})
						] }) : null,
						previousNotifications.length > 0 ? /* @__PURE__ */ jsxs(Fragment, { children: [
							/* @__PURE__ */ jsx(Header, { title: i18n._(
								/** i18n */
								{ id: "SMpzCG" }
							) }),
							/* @__PURE__ */ jsx(Divider, {}),
							/* @__PURE__ */ jsx("div", {
								className: "overflow-y-scroll",
								children: previousNotifications.map((notification) => /* @__PURE__ */ jsx(Item, { notification }, notification.id))
							})
						] }) : null
					]
				}),
				/* @__PURE__ */ jsx(Divider, {}),
				/* @__PURE__ */ jsx(Footer, { linkPortal: core?.linkPortal })
			]
		})]
	});
};
//#endregion
export { NotificationList };
